import React from "react";
import { useSelector } from "react-redux";

import Layout from "../../../components/UI/Layout/Layout";
import ContasReceberList from "./ContasReceberList";
import { LoadingTopBar } from "~/components/UI/LoadingTopBar";

export var ScreensContasReceber = function() {
    var contasReceber = useSelector(function(state) {
        return state.contasReceber;
    });
    var isLoading = contasReceber && contasReceber.isLoading;

    return (
        <div>
            <LoadingTopBar isActive={isLoading} />
            <Layout>
                <ContasReceberList />
            </Layout>
        </div>
    );
};
